import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {VideoCameraRegularIcon} from 'shells/icon/svg/video-camera-regular-icon';
import {IconSection} from 'shells/icon-section/icon-section';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {useGetZoomIntegration} from '../../../scheduler/location/conferencing-modals/graphql/hooks/use-get-zoom-integration';

import {useProvisionZoomAsync} from '../../graphql/hooks/use-provision-zoom-async';

import type {VideoConferencingData} from './hooks/use-calendar-state';

import styles from './video-conferencing-section.module.css';

type Props = {
    videoConferencingData: VideoConferencingData | null;
    setVideoConferencingData: (data: VideoConferencingData | null) => void;
};

export function VideoConferencingSection(props: Props) {
    const {videoConferencingData, setVideoConferencingData} = props;

    const {zoomIntegration} = useGetZoomIntegration();
    const {provisionZoomAsync} = useProvisionZoomAsync();

    const handleCreateZoomMeeting = async () => {
        const meeting = await provisionZoomAsync();
        if (meeting) {
            setVideoConferencingData({
                meetingId: meeting.meetingId,
                meetingUuid: meeting.meetingUuid,
                meetingUrl: meeting.meetingUrl,
                serviceType: meeting.serviceType as VideoConferencingData['serviceType'],
            });
        }
    };

    return (
        <IconSection icon={VideoCameraRegularIcon}>
            <div className={styles['container']}>
                {videoConferencingData ? (
                    <div>
                        <Body size='small'>{videoConferencingData.meetingUrl}</Body>
                    </div>
                ) : (
                    <>
                        {zoomIntegration?.isEnabled ? (
                            <Button onClick={handleCreateZoomMeeting}>Create Zoom Meeting</Button>
                        ) : (
                            <Link
                                // @ts-expect-error
                                as={RoutedLink}
                                to='/sales/meetings/zoom'
                                variant='button-primary'
                            >
                                Connect Zoom
                            </Link>
                        )}
                    </>
                )}
            </div>
        </IconSection>
    );
}
